import GlobalUploadProgressToast from "@/components/UploadProgress/GlobalUploadProgressToast";
import { Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import appInfo from "./app-info";
import routes from "./app-routes";
import ItiLoading from "./iti-core-react/components/ItiLoading/ItiLoading";
import { NotificationProvider } from "./shared/components/NotificationsPanel/NotificationContext";
import { SideNavInnerToolbar } from "./shared/layouts";

export default function Content({
	showHeaderAndMenu,
}: { showHeaderAndMenu: boolean }) {
	return (
		<>
			{!showHeaderAndMenu ? (
				<NotificationProvider>
					<SideNavInnerToolbar
						title={appInfo.title}
						isInIframe={window.self !== window.top}
					>
						<Suspense fallback={<ItiLoading />}>
							<Routes>
								{routes.map(({ path, element }) => (
									<Route key={path} path={path} element={element} />
								))}
							</Routes>
							<Outlet />
						</Suspense>
					</SideNavInnerToolbar>
				</NotificationProvider>
			) : (
				<Suspense fallback={<ItiLoading />}>
					<Routes>
						{routes.map(({ path, element }) => (
							<Route key={path} path={path} element={element} />
						))}
					</Routes>
					<Outlet />
				</Suspense>
			)}

			{/* Toast global de progreso de subida - visible en todas las páginas */}
			<GlobalUploadProgressToast autoHide={true} />
		</>
	);
}
